import * as Yup from 'yup';

import i18n from '@/i18n';

export const AddSlotValidationScheme = Yup.object().shape({
  slotTypeId: Yup.number().moreThan(0, i18n.t('slotTypeRequired', { ns: 'common' }))
});
